module.exports = __webpack_public_path__ + "img/map.6af15109.jpg";